module.exports = __webpack_public_path__ + "f83538c864f02389983186209c63f3cc.svg";